import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import AdminSidebar from "./AdminSidebar";
import AdminTopbar from "./AdminTopbar";
import AdminOverview from "./AdminOverview";

const pageVariants = {
  initial: { opacity: 0, y: 12 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.28, ease: [0.4, 0, 0.2, 1] },
  },
  exit: {
    opacity: 0,
    y: -8,
    transition: { duration: 0.18, ease: [0.4, 0, 0.2, 1] },
  },
};

export default function AdminLayout({
  user,
  onLogout,
  viewMode,
  setViewMode,
  projects,
  children,
}) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <AdminSidebar
        viewMode={viewMode}
        setViewMode={setViewMode}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        onLogout={onLogout}
        user={user}
      />

      {/* Main Area */}
      <div className="admin-main">
        {/* Topbar */}
        <AdminTopbar
          viewMode={viewMode}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          onMobileMenuOpen={() => setMobileOpen(true)}
          user={user}
          onLogout={onLogout}
        />

        {/* Scrollable Content */}
        <main className="admin-content">
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={viewMode}
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              style={{ height: "100%" }}
            >
              {viewMode === "overview" ? (
                <AdminOverview projects={projects} />
              ) : (
                <div className="admin-panel">{children}</div>
              )}
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </div>
  );
}
